var map = {
	"./Banking.jpeg": 49,
	"./Buno Seats.png": 860,
	"./Table.jpeg": 667,
	"./Table.png": 98,
	"./TaxCalc.jpg": 398,
	"./UnitConv.png": 852,
	"./blog-6.jpg": 757,
	"./chatApp.jpg": 781,
	"./pexels-obsahovka-obsahovka-4449784.jpg": 940,
	"./tetris.png": 399,
	"./weather.png": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;